var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gallery-item" }, [
    _c(
      "div",
      {
        staticClass: "row items-end no-wrap",
        staticStyle: { height: "1.6em" }
      },
      [
        _c("q-icon", {
          attrs: { name: _vm.$utils.contentIcon(_vm.item.value.contentType) }
        }),
        _vm._v(" "),
        _c("small", [_vm._v(_vm._s(_vm.item.value.contentType.split("/")[1]))]),
        _vm._v(" "),
        _vm.item.value.size
          ? _c("small", [
              _vm._v(
                "(" + _vm._s(_vm._f("formatSize")(_vm.item.value.size)) + ")"
              )
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "small-label" },
      [
        _c("q-icon", { attrs: { name: "colorize" } }),
        _vm._v(_vm._s(_vm.editor) + "\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "small-label" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm._f("formatTime")(_vm.item.value.lastEdited)) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.notReader
      ? _c(
          "div",
          {
            staticClass: "absolute",
            staticStyle: {
              top: "0",
              right: "0",
              "background-color": "rgba(255, 255, 255, 0.8)"
            }
          },
          [
            _vm.showEdit
              ? _c("q-btn", {
                  attrs: {
                    color: "primary",
                    icon: "more_vert",
                    dense: "",
                    round: "",
                    flat: "",
                    title: "Действия"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.goEdit(_vm.item)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bg-light row justify-center cursor-pointer",
        staticStyle: { height: "100px" },
        on: {
          click: function($event) {
            _vm.view(_vm.item)
          }
        }
      },
      [
        _vm.item.value.contentType.indexOf("audio") === 0
          ? _c("q-icon", {
              attrs: { name: "play_arrow", color: "faded", size: "60px" }
            })
          : _vm.thumbUrl
            ? _c("img", { attrs: { src: _vm.thumbUrl } })
            : _c("q-icon", {
                attrs: {
                  name: _vm.$utils.contentIcon(_vm.item.value.contentType),
                  color: "faded",
                  size: "60px"
                }
              })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          "text-secondary": _vm.item.value.local && _vm.item.value._linkcount,
          "text-primary": !_vm.item.value.local && _vm.item.value._linkcount,
          "cursor-pointer": _vm.item.value._linkcount
        },
        on: { click: _vm.goToLink }
      },
      [
        _c("q-icon", {
          attrs: { name: _vm.$utils.icon(_vm.item.value.link.from) }
        }),
        _vm._v(" "),
        _c("small", [_vm._v(_vm._s(_vm.name))])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6703e8e6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6703e8e6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/galery-item.vue
// module id = null
// module chunks = 